module.exports = __webpack_public_path__ + "static/media/cool bastards website42 final .7338243c.mov";